module.exports = __webpack_public_path__ + "img/strategies.4337e4f8.svg";